const UNKNOWN_VERSION = "unknown";

function pickFirstString(candidates: Array<string | undefined>): string {
  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim().length > 0) {
      return candidate.trim();
    }
  }

  return UNKNOWN_VERSION;
}

function shortSha(value: string | undefined): string | undefined {
  if (typeof value !== "string" || value.trim().length === 0) {
    return undefined;
  }

  return value.trim().slice(0, 12);
}

export function getAppVersion(): string {
  return pickFirstString([
    process.env.NEXT_PUBLIC_APP_VERSION,
    process.env.SENTRY_RELEASE,
    process.env.npm_package_version,
  ]);
}

export function getReleaseName(): string {
  return pickFirstString([
    process.env.SENTRY_RELEASE,
    process.env.NEXT_PUBLIC_APP_VERSION,
    process.env.npm_package_version,
  ]);
}

export function getServerBuildId(): string {
  return pickFirstString([
    process.env.NEXT_PUBLIC_BUILD_ID,
    process.env.NEXT_PUBLIC_APP_VERSION,
    shortSha(process.env.GIT_COMMIT_SHA),
    shortSha(process.env.GIT_COMMIT),
    shortSha(process.env.VERCEL_GIT_COMMIT_SHA),
    shortSha(process.env.GITHUB_SHA),
    process.env.BUILD_ID,
    shortSha(process.env.CI_COMMIT_SHA),
  ]);
}

type NextDataWindow = Window & {
  __NEXT_DATA__?: {
    buildId?: string;
  };
};

export function getClientBuildId(targetWindow?: NextDataWindow): string {
  if (
    typeof process.env.NEXT_PUBLIC_BUILD_ID === "string" &&
    process.env.NEXT_PUBLIC_BUILD_ID.trim().length > 0
  ) {
    return process.env.NEXT_PUBLIC_BUILD_ID.trim();
  }

  const nextDataBuildId = targetWindow?.__NEXT_DATA__?.buildId;
  if (typeof nextDataBuildId === "string" && nextDataBuildId.trim().length > 0) {
    return nextDataBuildId.trim();
  }

  return getServerBuildId();
}
